import { ActionMap } from 'action-typed';

import { ProductAttrs } from 'src/components/ProductDetail/utils/product-attrs.types';
import { BaseProduct, DataSheet, Specification } from 'src/components/ProductDetail/utils/product-detail.types';
import { Reviews } from 'src/components/Reviews/reviews.types';
import { ProductPrice } from 'src/types/global-types';

export enum ProductEvents {
    VIEW_PRODUCT = 'Product.View',
}

export type Product = Partial<BaseProduct> & {
    attrs?: ProductAttrs;
    benefits?: string[];
    dataSheets?: DataSheet[];
    isComingSoon?: boolean;
    pathname?: string;
    price?: ProductPrice;
    product?: BaseProduct;
    reviews?: Reviews | null;
    specifications?: Specification[];
};

export type Messages = {
    [ProductEvents.VIEW_PRODUCT]: Product;
};

export type TypeMap = ActionMap<Messages>;
export type ProductActions = TypeMap[keyof TypeMap];

export function isProductAction(action: any): action is ProductActions {
    return Object.values(ProductEvents).includes(action.type);
}
